<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-content-save</v-icon>
       <v-spacer></v-spacer>
       <v-row>
     <v-col cols="12" sm="6" md="4">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4">
      <v-menu
        style="z-index: 9999"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Fecha"
            prepend-icon="mdi-calendar"
            readonly
            single-line
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
      </v-menu>
    </v-col>
    </v-row>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="logs"
    :search="search"
    class="elevation-1"
    >
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    date: '',
    menu2: false,
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [],
    logs: [],
    editedIndex: -1,
    config:{
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Rol' : 'Editar Rol'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    console.log(this.$store.state.toolbar_title)
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_log', {'ExecuteProcessStart_Dt': '2019-12-18'}, this.config)
      .then(response => {
        this.logs = response.data["rows"]
        this.headers = response.data["headers"]
      })
      .catch(error => {
        this.logs = []
        if(error.response.status == 401) {
           this.$router.push('home')
        }
        alert(error.response.data.message)
      })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ApiProcessLogGrid.vue